import { useAppContext } from "../context/appContext";

import { Navigate } from "react-router";
import { isAdmin } from "../utils/permissions";

const ProtectedPrivilegedRoute = ({ children }) => {
  const { user } = useAppContext();

  const admin = isAdmin(user);

  if (!user?.email || !admin) {
    return <Navigate to="/" />;
  }
  return children;
};

export default ProtectedPrivilegedRoute;
